import {} from '../../utils/setting'
export const style = (theme) =>({
  root: {
    marginTop: theme.spacing(2),
    padding: 0,
    width: '100%',
  },
  appTabs: {
    boxShadow: 'none',
    marginBottom: theme.spacing(3),
    backgroundColor: "transparent",
    textTransform: 'uppercase'
  },
  tabsFixed: {
    overflowX: 'auto !important'
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: theme.palette.secondary,
    // backgroundColor: '#1890ff',
  },
  tabRoot: {
    maxWidth: theme.spacing(30),
    minWidth: theme.spacing(9),
    minHeight: theme.spacing(6),
    marginRight: theme.spacing(2),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  textColorPrimary: {
    fontWeight: "500",
    textTransform: "uppercase",
    lineHeight: 1.75,
    whiteSpace: "normal",
    letterSpacing: "0.02857em",
    fontSsize: "0.8125rem",
    color: "#000",
    opacity: 0.7
  },
  selected: {
    color: "#000 !important",
    opacity: "1 !important"
  },
})
export const styleAddPayment = (theme) => ({
  content: {
    padding: '32px 56px'
  },
  button: {
    margin: '0.5rem',
  }, 
}) 